import { render, staticRenderFns } from "./JoiningPersonalDetails.vue?vue&type=template&id=9fb8700a&scoped=true"
import script from "./JoiningPersonalDetails.vue?vue&type=script&lang=js"
export * from "./JoiningPersonalDetails.vue?vue&type=script&lang=js"
import style0 from "./JoiningPersonalDetails.vue?vue&type=style&index=0&id=9fb8700a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb8700a",
  null
  
)

export default component.exports